<div class='appt-time-loader' *ngIf="(availabilityOptionsLoading$ | async)">
</div>
<div class='appointment-container' *ngIf="!(availabilityOptionsLoading$ | async)">
  <form [formGroup]='step' appConnectStore="availabilityForm">
    <app-splitter class='app-splitter'  [config]="'horizontal 100% 0 -.4rem 550px'"></app-splitter>
    <div class='availability'>
      <section class='availability-header'>
        {{ 'service.appointmentAvailability' | translate}}
      </section>


      <app-availability *ngIf="languageId!=='' && isEditMode; else noEdit" 
                        class='app-availability'
                        formControlName='availability'
                        [options]="availabilityOptions$ | async"
                        [source]="'appointment'"
                        [selectedTransport]="transport"
                        [isAvailabilityLoading]="availabilityLoading$ | async"
                        [availability]="availability$ | async"
                        (monthChanged)="onMonthChange($event)"
                        (timeSlotValidator)="setValidatorsForTimeSlot($event)"
                        [vin]="vin"
                        [appointmentId]="appointmentId"
                        [customerLanguage]="languageId"
                        [isEditMode]="isEditMode"
                        [apptType]="apptType"
                        [apptAdvisor]="apptAdvisor">
      </app-availability>
      <ng-template #noEdit>
        <app-availability 
                        class='app-availability'
                        formControlName='availability'
                        [options]="availabilityOptions$ | async"
                        [source]="'appointment'"
                        [selectedTransport]="transport"
                        [isAvailabilityLoading]="availabilityLoading$ | async"
                        [availability]="availability$ | async"
                        (monthChanged)="onMonthChange($event)"
                        (timeSlotValidator)="setValidatorsForTimeSlot($event)"
                        [vin]="vin"
                        [appointmentId]="appointmentId"
                        [apptType]="apptType">
      </app-availability>
      </ng-template>
    </div>
  </form>
</div>
